import { render, staticRenderFns } from "./LocaleSwitcher.vue?vue&type=template&id=e81bba08&scoped=true"
import script from "./LocaleSwitcher.vue?vue&type=script&lang=ts"
export * from "./LocaleSwitcher.vue?vue&type=script&lang=ts"
import style0 from "./LocaleSwitcher.vue?vue&type=style&index=0&id=e81bba08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e81bba08",
  null
  
)

export default component.exports